
define('text!views/pages/cash/deposit/ChooseDepositValuableViewModel.html',[],function () { return '<div data-bind="depositValuablesList"></div>\n';});

